import { beSetupAxiosInstance } from '../../axios/beSetupAxios';
import { AgreementStatusEnum } from '../../enum/agreementStepStatus';
import { ApplicationStatusEnum } from '../../enum/applicationStepStatus';

const getAllRefinances = async (requestData: any) => {
  const params = {
    filters: requestData.filters,
    search: requestData.search,
    sortField: requestData.sortField,
    sortOrder: requestData.sortOrder,
    currentPage: requestData.pagination.current,
    pageSize: requestData.pagination.pageSize,
  };
  const url = `/redCash/admin/api/v1.0/refinances`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getRefinances = async (requestData: any) => {
  const params = {
    filters: requestData.filters,
    search: requestData.search,
    sortField: requestData.sortField,
    sortOrder: requestData.sortOrder,
    currentPage: requestData.pagination.current,
    pageSize: requestData.pagination.pageSize,
  };
  const url = `/redCash/admin/api/v1.0/refinances/applicationStatus/${
    requestData.applicationStatus
  }${requestData.agreementStatus ? `/agreementStatus/${requestData.agreementStatus}` : ''}`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getSubmitForApprovalRefinance = async (requestData: any) => {
  requestData.applicationStatus = ApplicationStatusEnum.SUBMITTED_FOR_APPROVAL;
  return await getRefinances(requestData);
};

const getPendingRefinances = async (requestData: any) => {
  requestData.applicationStatus = ApplicationStatusEnum.PENDING;
  return await getRefinances(requestData);
};

const getReferbackRefinances = async (requestData: any) => {
  requestData.applicationStatus = ApplicationStatusEnum.REFERBACK;
  return await getRefinances(requestData);
};

const getApprovedRefinances = async (requestData: any) => {
  requestData.applicationStatus = ApplicationStatusEnum.APPROVED;
  return await getRefinances(requestData);
};

const getRejectedRefinances = async (requestData: any) => {
  requestData.applicationStatus = ApplicationStatusEnum.REJECTED;
  return await getRefinances(requestData);
};

const getCancelledRefinances = async (requestData: any) => {
  requestData.applicationStatus = ApplicationStatusEnum.CANCELED;
  return await getRefinances(requestData);
};

const getOpenRefinances = async (requestData: any) => {
  requestData.applicationStatus = ApplicationStatusEnum.DRAFT;
  return await getRefinances(requestData);
};

const getSubmitForApprovalRefinances = async (requestData: any) => {
  requestData.applicationStatus = ApplicationStatusEnum.SUBMITTED_FOR_APPROVAL;
  return await getRefinances(requestData);
};

const getApprovedReviewRefinances = async (requestData: any) => {
  requestData.applicationStatus = ApplicationStatusEnum.APPROVED;
  return await getRefinances(requestData);
};

const getRefinanceFinanceListing = async (requestData: any) => {
  requestData.applicationStatus = ApplicationStatusEnum.APPROVED;
  requestData.agreementStatus = AgreementStatusEnum.DISBURSED;
  return await getRefinances(requestData);
};

const getRefinanceDetails = async (requestData: any) => {
  const { refinanceId } = requestData;
  const url = `/redCash/admin/api/v1.0/refinance/${refinanceId}`;
  const res = await beSetupAxiosInstance.get(url);
  return res.data;
};

const getRefinanceDetailsByApplicationId = async (requestData: any) => {
  const { applicationId } = requestData;
  const url = `/redCash/admin/api/v1.0/refinance/applicationId/${applicationId}`;
  const res = await beSetupAxiosInstance.get(url);
  return res.data;
};

const getRefinanceDetailsByAgreementId = async (requestData: any) => {
  const { agreementId } = requestData;
  const url = `/redCash/admin/api/v1.0/refinance/agreementId/${agreementId}`;
  const res = await beSetupAxiosInstance.get(url);
  return res.data;
};

const getCompletedRefinanceDetailsByOldAgreementNoThunk = async (requestData: any) => {
  const { oldAgreementNo } = requestData;
  const url = `/redCash/admin/api/v1.0/refinance/completed/oldAgreementNo/${oldAgreementNo}`;
  const res = await beSetupAxiosInstance.get(url);
  return res.data;
};

const createRefinance = async (requestData: any) => {
  const url = `/redCash/admin/api/v1.0/refinance`;
  const config = {
    headers: {
      'content-Type': 'multipart/form-data',
    },
  };
  const res = await beSetupAxiosInstance.post(url, requestData, config);
  return res.data;
};

const updateRefinanceEffectiveDate = async (requestData: any) => {
  const { id, effectiveDate } = requestData;
  const url = `/redCash/admin/api/v1.0/refinance/${id}/effectiveDate`;
  const res = await beSetupAxiosInstance.patch(url, { effectiveDate });
  return res.data;
};

const updateRefinanceFee = async (requestData: any) => {
  const { id, refinanceFee } = requestData;
  const url = `/redCash/admin/api/v1.0/refinance/${id}/refinanceFee`;
  const res = await beSetupAxiosInstance.patch(url, { refinanceFee });
  return res.data;
};

const refinanceService = {
  getAllRefinances,
  getOpenRefinances,
  getPendingRefinances,
  getReferbackRefinances,
  getApprovedRefinances,
  getRejectedRefinances,
  getCancelledRefinances,
  getSubmitForApprovalRefinances,
  getRefinanceDetails,
  getRefinanceDetailsByApplicationId,
  getRefinanceDetailsByAgreementId,
  getCompletedRefinanceDetailsByOldAgreementNoThunk,
  updateRefinanceEffectiveDate,
  getSubmitForApprovalRefinance,
  getApprovedReviewRefinances,
  getRefinanceFinanceListing,
  updateRefinanceFee,
  createRefinance,
};

export default refinanceService;
